var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgRocketLaunch = function SvgRocketLaunch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82187 17.3242C7.75312 20.5023 3.51562 20.5023 3.51562 20.5023C3.51562 20.5023 3.51562 16.2648 6.69375 15.196",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3654 9.89908L11.9998 16.2647L7.75293 12.0178L14.1186 5.65221C16.5279 3.24283 18.9373 3.27096 19.9686 3.42096C20.1277 3.44219 20.2754 3.5152 20.3889 3.62871C20.5024 3.74223 20.5754 3.88995 20.5967 4.04908C20.7467 5.08033 20.7748 7.48971 18.3654 9.89908Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3063 10.9585V17.0147C17.3034 17.2126 17.2226 17.4013 17.0812 17.5397L14.0531 20.5772C13.9571 20.6732 13.8367 20.7413 13.705 20.7742C13.5733 20.8072 13.4351 20.8037 13.3052 20.7642C13.1752 20.7248 13.0585 20.6508 12.9673 20.5502C12.8761 20.4495 12.814 20.326 12.7875 20.1929L12 16.2647",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0593 6.71167H7.00306C6.80523 6.71449 6.61653 6.79536 6.47806 6.93667L3.44056 9.96479C3.3446 10.0609 3.27652 10.1812 3.24359 10.3129C3.21065 10.4446 3.2141 10.5828 3.25356 10.7128C3.29302 10.8427 3.36701 10.9595 3.46763 11.0506C3.56826 11.1418 3.69175 11.2039 3.82493 11.2304L7.75306 12.0179",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocketLaunch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket-launch.b0914ab2f9e8b918c008a4cb190e41f0.svg";
export { ForwardRef as ReactComponent };